import React from 'react';
import { titleize } from 'inflection';

import AnonEmployerAssociation from 'buyside/components/presentation/EmployerAssociation/anonEmployerAssociation';
import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';
import Badges from 'buyside/components/presentation/Badges/badges';
import EmployerAssociation from 'buyside/components/presentation/EmployerAssociation/employerAssociation';
import Link from 'buyside/components/presentation/Link/link';

import { profileUrl, rankingUrl } from 'buyside/util/urlHelper';
import { ActivityFeedRankFragment, Maybe } from 'interfaces/graphql-typings';

import styles from '../rankingStyles.scss';

const RankingUserSection: React.FC<{
  category: string;
  value: Maybe<number>;
  canViewUserDetails: boolean;
  user: ActivityFeedRankFragment['user'];
}> = ({ user, category, value, canViewUserDetails }) => (
  <div data-testid="ranking-user-section" className={styles.profileArea}>
    <div>
      <div>
        {canViewUserDetails && user?.profile?.id ? (
          <Link to={profileUrl(user?.profile?.id)}>{user?.displayName}</Link>
        ) : (
          <strong>
            <AnonymousUserDisplay anonUser={{ title: user?.mostRecentEmployer?.title }} />
          </strong>
        )}{' '}
        has risen to rank{' '}
        {typeof value === 'number' && (
          <Link to={rankingUrl(category)}>
            #{value + 1} in {category === 'general' ? 'All-Time' : titleize(category)}
          </Link>
        )}
      </div>
      <div>
        {canViewUserDetails ? (
          <EmployerAssociation mostRecentEmployer={user?.mostRecentEmployer} />
        ) : (
          <AnonEmployerAssociation
            aumRange={user?.mostRecentEmployer?.employer?.aumRange}
            fundType={user?.mostRecentEmployer?.employer?.fundType}
          />
        )}
      </div>
      <div className={styles.cityName}>{user?.profile?.city}</div>
      {Boolean(user?.userBadges?.edges?.length) &&
        user?.userBadges?.edges?.some(edge => edge?.node?.visible) && (
          <div className={styles.badgesGroup}>
            Badges:{' '}
            <Badges userBadges={user?.userBadges?.edges} inline badgeClass={styles.tinyBadge} />
          </div>
        )}
    </div>
  </div>
);

export default RankingUserSection;
